var _excluded = ["fontSize"],
  _excluded2 = ["appearance", "name", "src", "variant", "type", "size", "bg", "color"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { useState, useCallback, useMemo, memo } from 'react';
import styled, { css } from 'styled-components';
import classnames from 'classnames';
import Box from "../Box";
import Image from "../Image";
import Text from "../Text";
var defaultType = 'neutral';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
var AvatarText = styled(function (_ref) {
  var fontSize = _ref.fontSize,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Text, rest);
}).withConfig({
  displayName: "Avatar__AvatarText",
  componentId: "sc-1ffu253-0"
})(["font-size:", "px;color:", "px;"], function (props) {
  return props.fontSize;
}, function (props) {
  return props.color;
});
var Container = styled(Box).withConfig({
  displayName: "Avatar__Container",
  componentId: "sc-1ffu253-1"
})(["", ""], function (_ref2) {
  var theme = _ref2.theme,
    type = _ref2.type,
    variant = _ref2.variant,
    bg = _ref2.bg;
  return css(["color:", ";background:", ";"], theme.colors[type][variant === 'dark' ? '200' : '900'], bg ? bg : theme.colors[type][variant === 'dark' ? '900' : '200']);
});
var getInitials = function getInitials(name) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?';
  if (!name || typeof name !== 'string') return fallback;
  return name.replace(/\s+/, ' ').split(' ') // Repeated spaces results in empty strings
  .slice(0, 2).map(function (v) {
    return v && v[0].toUpperCase();
  }) // Watch out for empty strings
  .join('');
};
export var Avatar = function Avatar(_ref3) {
  var _ref3$appearance = _ref3.appearance,
    appearance = _ref3$appearance === void 0 ? 'circle' : _ref3$appearance,
    _ref3$name = _ref3.name,
    name = _ref3$name === void 0 ? '' : _ref3$name,
    src = _ref3.src,
    _ref3$variant = _ref3.variant,
    variant = _ref3$variant === void 0 ? 'light' : _ref3$variant,
    _ref3$type = _ref3.type,
    type = _ref3$type === void 0 ? defaultType : _ref3$type,
    _ref3$size = _ref3.size,
    size = _ref3$size === void 0 ? '40px' : _ref3$size,
    bg = _ref3.bg,
    color = _ref3.color,
    rest = _objectWithoutProperties(_ref3, _excluded2);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imageFailedLoading = _useState2[0],
    setImageFailedLoading = _useState2[1];
  var initials = useMemo(function () {
    return getInitials(name);
  }, [name]);
  var handleError = useCallback(function () {
    setImageFailedLoading(true);
  }, [setImageFailedLoading]);

  // Font size for initials is half the size of the avatar, rounded down.
  var fontSize = Math.floor(Number(size.replace('px', '')) * 0.4);
  return /*#__PURE__*/React.createElement(Container, _extends({
    className: classnames(variant),
    size: size,
    overflow: "hidden",
    borderRadius: appearance === 'leaf' ? '40% 0 40% 0' : '50%',
    position: "relative",
    display: "flex",
    flexShrink: 0,
    justifyContent: "center",
    alignItems: "center",
    title: name,
    bg: bg,
    variant: variant,
    type: type,
    "data-qa-user-avatar": name
  }, rest), !src || imageFailedLoading ? /*#__PURE__*/React.createElement(AvatarText, {
    lineHeight: size,
    fontWeight: "semibold",
    fontSize: fontSize,
    color: color
  }, initials) : /*#__PURE__*/React.createElement(Image, {
    alt: name,
    width: "auto",
    height: "100%",
    src: src,
    onError: handleError,
    m: 0
  }));
};
export default /*#__PURE__*/memo(Avatar);